import { useEffect, useRef, useState } from "react"
import { Button } from "atomize"
import { motion } from "framer-motion"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons"
import { theme } from "../settings/config"
import useHoldPress from "./useHoldPress"

export { HOLD_DELAY } from "./useHoldPress"

// La freccia della barra delle lezioni. Un tocco sposta di un passo; tenuta
// premuta salta di più — nel giorno, di una settimana: da lunedì a lunedì.
//
// Sul telefono non c'è posto per i due bottoni da una settimana del
// computer: il bottone si riempie da sotto (useHoldPress), e quando è pieno
// la freccia diventa doppia per un attimo, su un azzurro che stacca dalla
// barra arancione, cioè la stessa icona del computer. Con `onHold` assente
// il bottone è una freccia e basta.
function HoldArrowButton({ direction, title, onTap, onHold }) {
	const [hasJumped, setJumped] = useState(false)
	const jumpedTimer = useRef(null)

	const icon = direction > 0 ? faChevronRight : faChevronLeft

	useEffect(() => () => clearTimeout(jumpedTimer.current), [])

	const { fill, handlers, style } = useHoldPress({
		onTap,
		onHold:
			onHold &&
			(() => {
				setJumped(true)
				clearTimeout(jumpedTimer.current)
				jumpedTimer.current = setTimeout(() => setJumped(false), 700)
				onHold()
			}),
	})

	return (
		<motion.div whileTap={{ scale: 0.9 }}>
			<Button
				w="3.25rem"
				h="3.25rem"
				m="auto"
				pos="relative"
				bg={hasJumped ? theme.colors.gunmetal_lighter : theme.colors.surface}
				shadow={theme.shadows.accent}
				rounded={theme.rounded["20px"]}
				title={title}
				{...handlers}
				style={style}>
				<motion.div
					initial={{ scaleY: 0 }}
					animate={fill}
					style={{
						position: "absolute",
						inset: 0,
						background: theme.colors.gunmetal_lighter,
						transformOrigin: "bottom",
					}}
				/>
				<span style={{ position: "relative", display: "flex" }}>
					<FontAwesomeIcon icon={icon} color={theme.colors.gunmetal} />
					{hasJumped && <FontAwesomeIcon icon={icon} color={theme.colors.gunmetal} />}
				</span>
			</Button>
		</motion.div>
	)
}

export default HoldArrowButton
